<router-outlet name="auth"></router-outlet>
<router-outlet name="slider"></router-outlet>

<div class="wrapper" [class.this-root-page] = "isRootPage">
  <header class="space"></header>
  <jumbotron></jumbotron>
  <div class="space content-sapce">
    <div class="content-grid layout-corral">
      <left-content></left-content>
      <div class="main-content">
        <router-outlet></router-outlet>
        <div class="news-block" *ngIf="isHomePage">
          <div class="nb-header">
                <h2>Новости</h2>
                <a [routerLink]="newsUrl">Все новости</a>
          </div>
          <div class="nb-list">
              <div class="news-block-item" *ngFor="let news of newsList | slice:0:6">
                  <img [src]="poster(news)">
                  <div>{{header(news)}}</div>
                  <a [routerLink]="link(news)">Читать далее</a>
              </div>
          </div>
        </div>

      </div>
      <right-content></right-content>
    </div>
  </div>

  


  <footer class="space"></footer>
</div>
<fullscreen-gallery></fullscreen-gallery>
<cms-dialog dir="ltr"></cms-dialog>
